function selectFilterComponent() {
  const isMobile = window.innerWidth <= 750;
  return isMobile
      ? document.querySelector('custom-mobile-filter')
      : document.querySelector('custom-filter');
}
class CustomPagination extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 1;
      this.collectionsPerPage = parseInt(document.querySelector('#product-grid').getAttribute('data-collections-per-page'));
      this.filterComponent = selectFilterComponent();
      this.gridItems = document.querySelectorAll('#product-grid .grid__item');
      this.filteredItems = [...this.gridItems];
    }

    connectedCallback() {
        // Get the current page number from the URL
        const url = new URL(window.location.href);
        this.currentPage = parseInt(url.searchParams.get('navPage')) || 1;

        // Listen for filter changes from custom-filter component
        this.filterComponent.addEventListener('filterChanged', event => {
          
        const selectedFilters = event.detail;

        // Filter grid items based on selected filters
        this.filteredItems = this.filterGridItems(selectedFilters);
        this.reorderBlockItemsFirst();

        // Recalculate the total visible items count
        const visibleItemsCount = this.getVisibleItemsCount(this.filteredItems);

        // Update the URL with the selected filter values
        this.updateURLWithFilters(selectedFilters);

        // Update the pagination based on visible items count
        this.updatePagination(visibleItemsCount);

          const url = new URL(window.location.href);
          this.currentPage = parseInt(url.searchParams.get('navPage')) || 1;

          // Check if the "collectionFilter" parameter exists in the URL
          const collectionFilterParam = url.searchParams.get('collectionFilter');

          if (!collectionFilterParam) {
            // If the "collectionFilter" parameter does not exist, redirect to the page with no parameters
            const newURL = new URL(window.location.origin + window.location.pathname);
            window.location.href = newURL.href;
          }

          const paginationItem = document.querySelector('a[data-page="1"]');

          // Check if the element exists
          if (paginationItem) {
            // Create a click event
            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });

            // Dispatch the click event on the pagination item
            paginationItem.dispatchEvent(clickEvent);
          }
        });

        window.addEventListener('resize', () => {
          let newFilterComponent = selectFilterComponent();
          if (newFilterComponent !== this.filterComponent) {
              // Remove the event listener from the current filter component
              this.filterComponent.removeEventListener('filterChanged', this.handleFilterChange);

              // Update the filter component reference and add the event listener to the new one
              this.filterComponent = newFilterComponent;
              this.filterComponent.addEventListener('filterChanged', this.handleFilterChange);
          }
        });

        // Get the total grid items count
        this.gridItemsCount = this.gridItems.length;
        const totalPages = Math.ceil(this.gridItemsCount / this.collectionsPerPage); // Use Math.ceil to ensure the last page is displayed

        // Render the pagination items dynamically based on the total pages and current page
        this.innerHTML = '';
        const navigation = document.createElement('nav');
        navigation.classList.add('pagination');
        this.appendChild(navigation);

        const navList = document.createElement('ul');
        navList.classList.add('pagination__list', 'list-unstyled');
        navigation.appendChild(navList);

        // Add "Prev" item if not on the first page
        const prevItem = document.createElement('li');
        const prevLink = document.createElement('a');
        prevLink.classList.add('pagination__item', 'pagination__item--prev', 'pagination__item-arrow', 'link', 'motion-reduce');
        prevLink.setAttribute('aria-label', 'Previous page');
        prevLink.textContent = 'Prev';
        prevItem.appendChild(prevLink);
        navList.appendChild(prevItem);
        prevLink.addEventListener('click', () => {
          this.handlePaginationClick(this.currentPage - 1, navList);
        });

        for (let i = 1; i <= totalPages; i++) {
          const paginationItem = document.createElement('a');
          paginationItem.classList.add('pagination__item', 'link');
          paginationItem.textContent = i;
          paginationItem.setAttribute('data-page', i); // Set a data attribute to store the page number
          navList.appendChild(paginationItem);

          // Add a click event listener to handle page navigation
          paginationItem.addEventListener('click', () => {
            const pageNumber = parseInt(paginationItem.getAttribute('data-page'), 10);
            this.handlePaginationClick(pageNumber, navList);
          });

          // Add the pagination__item--current class and set aria attributes for the current page
          if (i === this.currentPage) {
            paginationItem.classList.add('pagination__item--current');
            paginationItem.setAttribute('aria-disabled', 'true');
            paginationItem.setAttribute('aria-label', 'Current Page');
          }
        }

        // Add "Next" item if not on the last page
        const nextItem = document.createElement('li');
        const nextLink = document.createElement('a');
        nextLink.classList.add('pagination__item', 'pagination__item--next', 'pagination__item-arrow', 'link', 'motion-reduce');
        nextLink.setAttribute('aria-label', 'Next page');
        nextLink.textContent = 'Next';
        nextItem.appendChild(nextLink);
        navList.appendChild(nextItem);

        nextLink.addEventListener('click', () => {
          this.handlePaginationClick(this.currentPage + 1, navList);
        });
        this.handlePrevAndNextButtons(navList);

        // Update grid item visibility based on the current page
        this.updateGridVisibility(this.currentPage, this.filteredItems);
      }

      handlePrevAndNextButtons(navList) {
        setTimeout(() => {
          // Update "Prev" and "Next" button logic
          const pageNumber = parseInt(document.querySelector('.pagination__item--current').getAttribute('data-page'), 10);
          const totalPages = Math.ceil(document.getElementById('product-grid').getAttribute('data-collection-count') / this.collectionsPerPage);
          const prevItem = navList.querySelector('.pagination__item--prev');
          const nextItem = navList.querySelector('.pagination__item--next');

          if (prevItem) {
            if (pageNumber === 1) {
              prevItem.style.display = 'none';
            } else {
              prevItem.style.display = 'inline-flex';
            }
          }

          if (nextItem) {
            if (pageNumber === totalPages) {
              nextItem.style.display = 'none';
            } else {
              nextItem.style.display = 'inline-flex';
            }
          }
        }, "100");
      }

      getVisibleItemsCount(gridItems) {
        let count = 0;
        gridItems.forEach(item => {
          if (item.style.display === 'block') {
            count++;
          }
        });
        return count;
      }

      updatePagination(filteredItemsCount) {
        // Calculate the total number of pages based on filtered items count
        const totalPages = Math.ceil(filteredItemsCount / this.collectionsPerPage);

        // Clear the current pagination
        const navList = this.querySelector('.pagination__list');
        navList.innerHTML = '';

        // Add "Prev" item if not on the first page
        const prevItem = document.createElement('li');
        const prevLink = document.createElement('a');
        prevLink.classList.add('pagination__item', 'pagination__item--prev', 'pagination__item-arrow', 'link', 'motion-reduce');
        prevLink.setAttribute('aria-label', 'Previous page');
        prevLink.textContent = 'Prev';
        prevItem.appendChild(prevLink);
        navList.appendChild(prevItem);
        prevLink.addEventListener('click', () => {
            this.handlePaginationClick(this.currentPage - 1, navList);
        });

        // Add page number items
        for (let i = 1; i <= totalPages; i++) {
            const paginationItem = document.createElement('a');
            paginationItem.classList.add('pagination__item', 'link');
            paginationItem.textContent = i;
            paginationItem.setAttribute('data-page', i);
            navList.appendChild(paginationItem);

            paginationItem.addEventListener('click', () => {
                const pageNumber = parseInt(paginationItem.getAttribute('data-page'), 10);
                this.handlePaginationClick(pageNumber, navList);
            });

            if (i === this.currentPage) {
                paginationItem.classList.add('pagination__item--current');
                paginationItem.setAttribute('aria-disabled', 'true');
                paginationItem.setAttribute('aria-label', 'Current Page');
            }
        }

        // Add "Next" item if not on the last page
        const nextItem = document.createElement('li');
        const nextLink = document.createElement('a');
        nextLink.classList.add('pagination__item', 'pagination__item--next', 'pagination__item-arrow', 'link', 'motion-reduce');
        nextLink.setAttribute('aria-label', 'Next page');
        nextLink.textContent = 'Next';
        nextItem.appendChild(nextLink);
        navList.appendChild(nextItem);
        nextLink.addEventListener('click', () => {
            this.handlePaginationClick(this.currentPage + 1, navList);
        });
    }

    // Modify the handlePaginationClick method to work with filtered items
    handlePaginationClick(pageNumber, navList) {
        // Update the URL with the new page parameter
        const newURL = new URL(window.location.href);
        newURL.searchParams.set('navPage', pageNumber);
        window.history.pushState({}, '', newURL);

        this.currentPage = pageNumber;

        // Remove the current class and aria attributes from all pagination items
        const paginationItems = this.querySelectorAll('.pagination__item');
        paginationItems.forEach(item => {
            item.classList.remove('pagination__item--current');
            item.removeAttribute('aria-disabled');
            item.removeAttribute('aria-label');
        });

        // Update the clicked pagination item
        const clickedPaginationItem = this.querySelector(`[data-page="${pageNumber}"]`);
        if (clickedPaginationItem) {
            clickedPaginationItem.classList.add('pagination__item--current');
            clickedPaginationItem.setAttribute('aria-disabled', 'true');
            clickedPaginationItem.setAttribute('aria-label', 'Current Page');
        }

        // Update grid item visibility based on the pageNumber and filtered items
        this.updateGridVisibility(pageNumber, this.filteredItems);

        // Update "Prev" and "Next" button logic
        this.handlePrevAndNextButtons(navList);
        
        const facesVerticalDiv = document.querySelector('#faces-vertical');
        if (facesVerticalDiv) {
          const offset = facesVerticalDiv.offsetTop - 100;
          const container = document.documentElement || document.body;
          container.scrollTop = offset;
        }
    }

    // Modify the updateGridVisibility method to work with filtered items
    updateGridVisibility(pageNumber, filteredItems) {
      // Calculate the range of items to display based on the current page and items per page
      const startIndex = (pageNumber - 1) * this.collectionsPerPage;
      const endIndex = startIndex + this.collectionsPerPage;
  
      // Loop through the filtered items and set the display property accordingly
      filteredItems.forEach((item, index) => {
        if (index >= startIndex && index < endIndex) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    }

    filterGridItems(selectedFilters) {
      // Create an array to store the filtered grid items
      const filteredItems = [];

      // Loop through grid items and hide/show based on selected filters
      this.gridItems.forEach(item => {
        const dataFilterValue = item.getAttribute('data-filter-value');
        if (selectedFilters.length === 0 || selectedFilters.includes(dataFilterValue)) {
          item.style.display = 'block'; // Show the item
          filteredItems.push(item); // Add the item to the filteredItems array
        } else {
          item.style.display = 'none'; // Hide the item
        }
      });
  
      return filteredItems; // Return the filtered items
    }

      reorderBlockItemsFirst() {
        const container = document.getElementById('product-grid');
        const blockItems = [];
        const nonBlockItems = [];
    
        // Separate block and non-block items
        this.filteredItems.forEach(item => {
          if (item.style.display === 'block') {
            blockItems.push(item);
          } else {
            nonBlockItems.push(item);
          }
        });
    
        // Sort block items based on data-title (alphabetical order)
        blockItems.sort((a, b) => {
          const titleA = a.getAttribute('data-title');
          const titleB = b.getAttribute('data-title');
          return titleA.localeCompare(titleB);
        });
    
        // Clear the container
        container.innerHTML = '';
    
        // Append sorted block items first
        blockItems.forEach(item => {
          container.appendChild(item);
        });
    
        // Append non-block items
        nonBlockItems.forEach(item => {
          container.appendChild(item);
        });
      }

      updateURLWithFilters(selectedFilters) {
        // Update the URL with the selected filter values
        const newURL = new URL(window.location.href);
        if (selectedFilters.length > 0) {
          newURL.searchParams.set('collectionFilter', selectedFilters.join(','));
        } else {
          newURL.searchParams.delete('collectionFilter');
        }
        window.history.pushState({}, '', newURL);
      }

      updateURLWithFiltersAndPage(selectedFilters, page) {
        // Update the URL with the selected filter values and page number
        const newURL = new URL(window.location.href);
        if (selectedFilters.length > 0) {
          newURL.searchParams.set('collectionFilter', selectedFilters.join(','));
        } else {
          newURL.searchParams.delete('collectionFilter');
        }
        newURL.searchParams.set('navPage', page);
        window.history.pushState({}, '', newURL);
      }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('custom-pagination', CustomPagination);
});
